export const slugs = {
  "new_batch": "/new-batches",
  "batches_details": "/admin/batches/",
  "all_batches": "/all-batches",
  "db_slug_batches": "batches",
  "db_slug_topics": "topics",

  "new_student_batch": "/new-student-batches",
  "student_batches_details": "/admin/student-batches/",
  "all_student_batches": "/all-dstudent-batches",
  "db_slug_student_batches": "student_batches",

  "new_employee": "/new-employee",
  "employee_details": "/admin/employee/",
  "all_employee": "/all-employee",
  "db_slug_employee": "employee",

  "new_expenses": "/new-expenses",
  "expenses_details": "/admin/expenses/",
  "all_expenses": "/all-expenses",
  "db_slug_expenses": "expenses",

  "new_invoices": "/new-invoices",
  "invoices_details": "/admin/invoices/",
  "all_invoices": "/all-invoices",
  "db_slug_invoices": "invoices",

  "new_payments_received": "/new-payments_received",
  "payments_received_details": "/admin/payments_received/",
  "all_payments_received": "/all-payments_received",
  "db_slug_payments_received": "payments_received",

  "new_students": "/new-students",
  "students_details": "/admin/students/",
  "all_students": "/all-students",
  "db_slug_students": "students",

  "new_teachers": "/new-teachers",
  "teachers_details": "/admin/teachers/",
  "all_teachers": "/all-teachers",
  "db_slug_teachers": "teachers",

  "new_user_data": "/new-user_data",
  "user_data_details": "/admin/user_data/",
  "all_user_data": "/all-user_data",
  "db_slug_user_data": "user_data",
}